/*
* A Shared class implementation.
* We could have done the same functionality using a global service
* injected along with the bootstrap(),
* but from the angular docs, it's highly discouraged.
*/
export class GlobalVariables {
    private static _locale: string = 'en';
    private static _supportedLocales: string[] = ['en'];
    public static get LOCALE(): string {
       return GlobalVariables._locale;
    }
    public static set LOCALE(locale: string) {
        GlobalVariables._locale = locale;
    }

    public static get SUPPORTED_LOCALES(): string[] {
        return GlobalVariables._supportedLocales;
    }

    public static set SUPPORTED_LOCALES(locales: string[]) {
        GlobalVariables._supportedLocales = (locales && locales.length > 0) ? locales : ['en'];
    }
}

export interface AppGlobal {
    path: string
    loadError: boolean;
}

export abstract class GlobalRef {
    abstract get nativeGlobal(): AppGlobal;
    abstract get isToShowDatacenterDesignerOverviewTour(): boolean;
    abstract set setShowDatacenterDesignerOverviewTour(isToShow: boolean);
    abstract get isToShowHcxServicesOverviewTour(): boolean;
    abstract set setShowHcxServicesOverviewTour(isToShow: boolean);
    abstract get isToShowHcxDashboardOverviewTour(): boolean;
    abstract set setShowHcxDashboardOverviewTour(isToShow: boolean);
}

export class BrowserGlobalRef extends GlobalRef {

    private showDatacenterDesignerOverviewTour: boolean = true;
    private showHcxServicesOverviewTour: boolean = true;
    private showHcxDashboardOverviewTour: boolean = true;

    get nativeGlobal(): AppGlobal {
        return window as any;
    }

    get isToShowDatacenterDesignerOverviewTour(): boolean {
        return this.showDatacenterDesignerOverviewTour;
    }

    set setShowDatacenterDesignerOverviewTour(isToShow: boolean) {
        this.showDatacenterDesignerOverviewTour = isToShow;
    }

    get isToShowHcxServicesOverviewTour(): boolean {
        return this.showHcxServicesOverviewTour;
    }

    set setShowHcxServicesOverviewTour(isToShow: boolean) {
        this.showHcxServicesOverviewTour = isToShow;
    }

    get isToShowHcxDashboardOverviewTour(): boolean {
        return this.showHcxDashboardOverviewTour;
    }

    set setShowHcxDashboardOverviewTour(isToShow: boolean) {
        this.showHcxDashboardOverviewTour = isToShow;
    }
}



// WEBPACK FOOTER //
// ./src/common/global-variables.ts